import { useEffect } from "react";

const HubspotScript = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//js-na1.hs-scripts.com/46247220.js";
    script.async = true;
    script.defer = true;
    script.id = "hs-script-loader";
    document.body.appendChild(script);

    return () => {
      // Limpieza al desmontar el componente (opcional)
      const existingScript = document.getElementById("hs-script-loader");
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return null;
};

export default HubspotScript;
